import React from 'react'
import './Navbar.css'
import Toggle from '../Toogle/Toggle'
import {Link} from 'react-scroll'
const Navbar = () => {
  return (
    <div className="n-wrapper">
        <div className="n-left">
            <div className="n-name">Akash</div>
            <Toggle/>
        </div>
        <div className="n-right">
            <div className="n-list">
                <ul style={{listStyleType:'none'}}>
                    <Link spy={true} to='Navbar' smooth={true} activeClass='activeClass'>
                        <li>Home</li>
                    </Link>
                    <Link spy={true} to='Services' smooth={true} activeClass='activeClass'>
                        <li>Services</li>
                    </Link>
                    <Link spy={true} to='Experience' smooth={true} activeClass='activeClass'>
                        <li>Experience</li>
                    </Link>
                    <Link spy={true} to='Portfolio' smooth={true} activeClass='activeClass'>
                        <li>Projects</li>
                    </Link>
                    <Link spy={true} to='Services' smooth={true} activeClass='activeClass'>
                        <li>Resume</li>
                    </Link>
                    <Link spy={true} to='Contacts' smooth={true} activeClass='activeClass'>
                        <button className="button n-button" >
                            Contact
                        </button>
                    </Link>
                </ul>
                
            </div>
        </div>
    </div>
  )
}

export default Navbar